import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const CTASection = ({ title, description, buttonText = 'Request a Quote', buttonLink = '/quote', showCall = true }) => {
  return (
    <section className="bg-[#003057] py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">{title}</h2>
          <p className="text-xl text-gray-300 mb-12">{description}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to={buttonLink}>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="btn-primary text-lg"
              >
                {buttonText}
              </motion.button>
            </Link>
            {showCall && (
              <a href="tel:+441753720055">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="btn-secondary text-lg"
                >
                  Call 24/7 Support
                </motion.button>
              </a>
            )}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
